import React, { ReactElement, useEffect, useState } from 'react';
import ModalContainer from 'components/molecules/ModalContainer';
import { Typography, Grid, Button, CircularProgress } from '@material-ui/core';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import useCategoriesIM from 'hooks/useCategoriesIM';
import { ICategories } from 'interfaces/imCategories.interface';

interface Props {
  open: boolean;
  categoryId: string;
  onClose(): void;
  getAllCategories(): void;
}

export default function IMCategoryDelete({ open, onClose, categoryId, getAllCategories }: Props): ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [warehouseToDelete, setPackageToDelete] = useState<ICategories>();
  const { getCategoryById, deleteCategory } = useCategoriesIM();

  const { showNotistack } = useCustomSnackbar();

  useEffect(() => {
    if (categoryId) {
      setIsLoading(true);
      getCategoryById(categoryId)
        .then((resultCategory: ICategories) => {
          setPackageToDelete(resultCategory);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [categoryId]);

  const handleOnClick = () => {
    deleteCategory(categoryId).then((response) => {
      if (response === true) {
        showNotistack({ message: 'La categoría se eliminó correctamente' });
        getAllCategories();
        onClose();
      } else {
        showNotistack({ message: 'Ocurrió un error al eliminar el categoría' });
      }
    });
  };
  return (
    <ModalContainer open={open} title="Eliminar categoría">
      <Grid container justify="center" alignItems="center">
        <Typography variant="h5">{`Estas seguro que deseas eliminar el registro: '${warehouseToDelete?.name}'?`}</Typography>
      </Grid>
      <Grid container justify="center">
        <Button
          onClick={handleOnClick}
          variant="contained"
          color="primary"
          disabled={isLoading}
          style={{ marginTop: 20 }}
        >
          {isLoading ? <CircularProgress size={24} /> : ''} Aceptar
        </Button>
        <Button
          variant="contained"
          color="default"
          disabled={isLoading}
          style={{ marginTop: 20, marginLeft: 20 }}
          onClick={onClose}
        >
          {isLoading ? <CircularProgress size={24} /> : ''} Cancelar
        </Button>
      </Grid>
    </ModalContainer>
  );
}
